export default __webpack_public_path__ + "static/media/human1.1880f30f.png";